import {
  Action,
  combineReducers,
  configureStore,
  ThunkAction,
} from '@reduxjs/toolkit'
import { UIReducer as UI } from './slices/UI'
import { OrganizerReducer as Organizer } from './slices/Organizer'
import { AccountReducer as Account } from './slices/Account'
import { EventReducer as Event } from './slices/Event'
import { QuizReducer as Quiz } from './slices/Quiz'
import { NewsReducer as News } from './slices/News'
import { FeedbackReducer as Feedback } from './slices/Feedback'

export const rootReducer = combineReducers({
  UI,
  Account,
  Organizer,
  Event,
  Quiz,
  News,
  Feedback,
})

export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
